import { ThemeProvider } from './ThemeContext';
import { WatchlistProvider } from './WatchlistContext';
import { PortfolioProvider } from './PortfolioContext';
import { AlertProvider } from './AlertContext';
import { DisplayModeProvider } from './DisplayModeContext';
import { RiskProfileProvider } from './RiskProfileContext';

export function AppProviders({ children }) {
  return (
    <DisplayModeProvider>
      <RiskProfileProvider>
        <ThemeProvider>
          <WatchlistProvider>
            <PortfolioProvider>
              <AlertProvider>{children}</AlertProvider>
            </PortfolioProvider>
          </WatchlistProvider>
        </ThemeProvider>
      </RiskProfileProvider>
    </DisplayModeProvider>
  );
}
